import { useSelector } from "react-redux"
import { Navigate, Outlet } from "react-router"
import { PageRoutes } from "@/constants/routes"
import { RootState } from "@/store"
import { UserRole } from "@/types/user"

type PrivateRouteProps = {
   allowedRoles?: UserRole[]
}

export default function PrivateRoute({ allowedRoles }: PrivateRouteProps) {
   const isAuthenticated = useSelector(
      ({ authReducer }: RootState) => authReducer.isAuthenticated
   )
   const userRole = useSelector(
      ({ userReducer }: RootState) => userReducer.role
   )

   if (!isAuthenticated) {
      return <Navigate to={PageRoutes.LOGIN} />
   }

   if (allowedRoles && userRole && !allowedRoles.includes(userRole)) {
      return <Navigate to={PageRoutes.FLOOR_OVERVIEW} />
   }

   return <Outlet />
}
